import { postApi } from 'api/fetchApi'
import { operations } from 'api/generated/messenger_support'

type Operation = operations['messenger_support_read_readMessages']
type Response = Operation['responses']['204']['schema']

export const markReadMessageSupportChatApi = () => {
  return postApi<Response, {}>('/messenger/support/read', {})
}
